import '@enonic/react-components/utils/initPublicPath';
import type {FC} from 'react';
import type {AppProps} from '../../types/AppProps';
import type {MetaData} from '@enonic/react-components';
import {BaseComponent} from '@enonic/react-components';
import {componentRegistry} from '../componentRegistry';


const App: FC<AppProps> = ({data, meta, common, component}) => {
	const compMeta: MetaData = meta as MetaData;
	compMeta.componentRegistry = componentRegistry;
	return (
		<BaseComponent data={data} component={component} meta={compMeta} common={common}/>
	);
}

App.displayName = 'App';

export default App;
